function initHomepageHeaderAnimations() {
    const tl = gsap.timeline();
    const photos = gsap.utils.toArray([".homepage__hero__photo-1", ".homepage__hero__photo-2", ".homepage__hero__photo-3"]);
    for (const photo of photos) {
        gsap.set(photo, { autoAlpha: 1 });
    }
    tl.from(photos, { opacity: 0, yPercent: 20, stagger: .2 })
}
initHomepageHeaderAnimations();